(function () {
    'use strict';

    angular
        .module('chilliAuth')
        .factory('ChilliAuthService', ChilliAuthService);

    ChilliAuthService.$inject = ['$timeout', '$rootScope', '$q', '$location', '$window', 'store', 'jwtHelper', 'chilliAuthConstants', 'lock'];
    function ChilliAuthService($timeout, $rootScope, $q, $location, $window, store, jwtHelper, chilliAuthConstants, lock) {
        var showLoginPromise = null;

        var service = {
            get isAuthenticated() { return getIsAuthenticated(); },
            get userName() { return getUserName(); },
            get idToken() { return getIdToken(); },
            getIdTokenPayload: getIdTokenPayload,
            showLogin: showLogin,
            logOut: logOut
        };

        return service;


        function getIsAuthenticated() {
            var token = getIdToken();
            if (token) {
                if (!jwtHelper.isTokenExpired(token)) {
                    return true;
                }
            }
            return false;
        }

        function getUserName() {
            var profile = store.get('profile');
            if (profile) {
                return profile.name;
            } else {
                return null;
            }
        }

        function getIdToken() {
            return store.get('token');
        }

        /**
         * Get the payload / content of the id token for the authenticated user.
         *
         * @returns {object}
         */
        function getIdTokenPayload() {
            var encodedToken = store.get('token');
            if (encodedToken) {
                return jwtHelper.decodeToken(encodedToken);
            } else {
                return null;
            }
        }

        /**
         * Show user login.
         * Detects the most appropriate login to display depending on the browser.
         */
        function showLogin() {
            return showLoginPopup();

            
            // Unfortunately, the newer version of lock (v11) doesn't allow us to override the 'container' option
            // subsequent to 'init'.
            // If we were going direct to Auth0Lock rather than using the provided Angular wrappers, we could create
            // a new Auth0Lock instance and work that way. But... given that this is just a workaround for IE11-like
            // browsers, and they're not so important (especially in this soon to be deprecated Angular 1.x version
            // of ChilliDocs), so... we just put up with having the default popup instead.

            /*if ($window.navigator.userAgent.indexOf('Trident') == -1) {
                return showLoginPopup();
            } else {
                // Internet Explorer or similar
                goToLoginPage();
                return $q.when(null);
            }*/
        }

        /**
         * Show a login popup.
         *
         * @returns {Promise} A promise that resolves once the user has successfully logged in.
         */
        function showLoginPopup() {
            if (showLoginPromise === null) {
                showLoginPromise = $q(function (resolve, reject) {
                    lock.show();

                    $rootScope.$on('chilliAuth:login', function () {
                        showLoginPromise = null;
                        resolve();
                    });
                });
            }

            return showLoginPromise;
        }

        /**
         * Go to the login page (not a popup).
         */
        function goToLoginPage() {
            $location.path(chilliAuthConstants.LOGIN_URL);
        }

        /**
         * Logout, including clearing token storage.
         */
        function logOut() {
            store.remove('profile');
            store.remove('token');
            appInsights.clearAuthenticatedUserContext();
            $rootScope.$emit('chilliAuth:logout');

            showLogin();
        }
    }
})();
